export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.06 23.49">
    <path d="M22.76 6.88L14.3.8a.69.69 0 0 0-.52-.12.72.72 0 0 0-.47.28L11.83 3V.71a.71.71 0 0 0-.71-.71H.71A.71.71 0 0 0 0 .71v18.87a.71.71 0 0 0 .71.71h6l4.26 3.06a.73.73 0 0 0 .42.14h.11a.67.67 0 0 0 .46-.29l11-15.33a.7.7 0 0 0 .13-.52.69.69 0 0 0-.33-.47zM1.42 1.42h9v17.45h-9zm9.76 20.37l-2.1-1.5h2a.71.71 0 0 0 .71-.71V5.46l2.22-3.09 7.31 5.24z" />
    <rect x="2.35" y="2.74" width="3.07" height="3.07" rx=".71" ry=".71" />
    <rect x="6.41" y="2.74" width="3.07" height="3.07" rx=".71" ry=".71" />
    <rect x="2.35" y="6.49" width="3.07" height="3.07" rx=".71" ry=".71" />
    <rect x="6.41" y="6.49" width="3.07" height="3.07" rx=".71" ry=".71" />
    <rect x="2.35" y="10.23" width="3.07" height="3.07" rx=".71" ry=".71" />
    <rect x="6.41" y="10.23" width="3.07" height="3.07" rx=".71" ry=".71" />
    <rect x="2.35" y="13.97" width="3.07" height="3.07" rx=".71" ry=".71" />
    <rect x="6.41" y="13.97" width="3.07" height="3.07" rx=".71" ry=".71" />
  </svg>
);
